import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { api_url } from "src/cms.js";

//
//	Smart search teen keyword ( search for 18 -19)
//
class SearchBox extends React.Component {

	constructor(props) {
		super(props);
		this.state = {searchInput: '', searchSuggestion:[]}		
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	//
	//	Update input text change
	//
	handleChange(event) {

		this.setState({ [event.target.name]: event.target.value});

		console.log( event.target.value );

		if( event.target.value.length >= 4 ) {


			fetch( api_url + '/api/search-suggestion/?q='+event.target.value)
			.then( results => { return results.json() })
			.then( data => {
				
				document.getElementById('searchSuggest').style.width = document.getElementById('search-input').offsetWidth + 'px';

				if( data.length > 0 ) {

					this.setState({searchSuggestion: data });
					
					document.getElementById("searchSuggest").style.display = "block";

				} else {

					document.getElementById("searchSuggest").style.display = "none";

				}
				
			})
		}
	}


	//	Submit form
	handleSubmit(event) {

		event.preventDefault();
		
		window.location="/search/"+this.state.searchInput.replace(/ /g, '-')+'/';
		
	}

	// Have to set as html or else the <span> shows as text instead of html tag.
	highlightMatch(text) {

		return{ __html: text.replace( this.state.searchInput, "<span>"+this.state.searchInput+"</span>" )}
		
	}

	render() {
		return (
			<form id="formSearch" onSubmit={this.handleSubmit}>
				<input type="text" name="searchInput" className="search-input" id="search-input" autoComplete="off" placeholder="Search..." onChange={this.handleChange} />
				<button id="search-button" title="Search">
					<FontAwesomeIcon icon={faSearch} />
				</button>
				<ul id="searchSuggest">
				{this.state.searchSuggestion.map( (text) =>
					<li key={text}>
						<a href={'/search/'+text.replace(' ', '-')+'/'} dangerouslySetInnerHTML={this.highlightMatch(text)}></a>
					</li>
				)}
				</ul>
			</form>
		);
	}
}


export default SearchBox;



// WEBPACK FOOTER //
// ./src/components/parts/SearchBox.js